import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { ThisReceiver } from '@angular/compiler';
import { AfterViewInit, ChangeDetectionStrategy, SimpleChanges, Component, OnChanges, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { Observable } from 'rxjs/internal/Observable';
import { ConsultantsService } from 'src/app/+home/+seller-consultants/shared/services/consultants.service';
import { map, startWith } from 'rxjs/operators';


interface AutocompleteChipsInputOption<T> {
  label: string;
  id: T;
}

@Component({
  selector: 'autocomplete-chips-input',
  templateUrl: './autocomplete-chips-input.component.html',
  styleUrls: ['./autocomplete-chips-input.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AutocompleteChipsInputComponent implements OnInit, AfterViewInit, OnChanges {

  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  filteredOptions: Observable<AutocompleteChipsInputOption<any>[]>;
  @Input('placeholder') placeholder: string;
  inputControl = new FormControl();
  @Output('selectedOptions') selectedOptions: EventEmitter<string[]>;
  @Output('newItem') newItem: EventEmitter<string> = new EventEmitter;
  @Input('initOptions') initOptions: any[];
  @Input('allOptions') allOptions: AutocompleteChipsInputOption<string>[];
  @ViewChild('optionsInput') optionsInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  isNewItem: boolean = false;
  newItemValue: string = '';


  visible = true;
  addOnBlur = false;
  options: string[] = [];

  constructor(private consultantService: ConsultantsService) {
    this.selectedOptions = new EventEmitter<string[]>();
    this.filteredOptions = this.inputControl.valueChanges.pipe(
      startWith(null),
      map((option: string | null) => option ? this._filter(option) : this.allOptions.slice()));
  }

  ngOnInit(): void {

    //this.removable = this.allOptions.length > 1;
  }

  ngOnChanges(changes: SimpleChanges) { }


  async add(event: MatChipInputEvent) {
    const input = event.input;
    const value = event.value;


    // Add our option
    if ((value || '').trim()) {
      //this.newItem.emit(value);
      try {
        const res = await this.consultantService.addNewSkill(value);
        this.allOptions = [{ id: res._id, label: res.title }, ...this.allOptions];
        this.initOptions.push({ id: res._id, label: res.title });
        this.selectedOptions.emit(this.initOptions.map(o => o.id));

        //thi0s.initialize();
        // TODO Afficher tout va bien
      } catch (e) {
        // TODO Afficher errreur
      } finally {

      }


    }

    // Reset the input value
    if (input) {
      input.value = '';
    }


    this.inputControl.setValue(null);
  }


  remove(option): void {

    const index = this.initOptions.map(o => o.id).indexOf(option.id);

    if (index >= 0) {
      this.initOptions.splice(index, 1);

      this.selectedOptions.emit(this.initOptions.map(o => o.id));
    }

  }

  selected(event: MatAutocompleteSelectedEvent): void {
    const option = this.allOptions.find(f => f.id === event.option.value);

    if (option) {
      this.initOptions.push(option);
      this.selectedOptions.emit(this.initOptions.map(o => o.id));
      this.optionsInput.nativeElement.value = '';
      this.inputControl.setValue(null);
    }
  }

  remainingOptions() {
    return this.allOptions.filter(s => !this.initOptions.map(o => o.id).includes(s.id));
  }

  ngAfterViewInit(): void {
    this.filteredOptions = this.inputControl.valueChanges.pipe(
      map((option: string) => option ? this._filter(option) : this.remainingOptions()));
  }

  private _filter(value: string) {
    const filterValue = value.toLowerCase();
    return this.remainingOptions().filter(s => s.label.toLowerCase().indexOf(filterValue) === 0 || s.id.indexOf(value) === 0);
  }
}
